<template>
  <multiselect-item
    id="instalador"
    v-model="instalador"
    :custom-label="label"
    :options="instaladorOptions"
    placeholder="Seleccione instalador"
    track-by="id_instaladores"
    :loading="isLoading"
  ></multiselect-item>
</template>

<script>
import { get } from "lodash-es";
import axios from "axios";
import AdaptarVueModel from "../../shared/AdaptarVueModel";

export default {
  name: "SelectInstalador",
  props: {
    value: {
      default: null,
    },
  },
  mixins: [AdaptarVueModel],
  mounted() {
    this.getInstaladores().then((resp) => {
      if (!resp.ok) {
        this.$msgBoxOk(resp.message);
      }
    });
  },
  data: () => ({
    instaladorOptions: [],
    isLoading: true,
  }),
  methods: {
    label(instalador) {
      return `${instalador.id_instaladores} - ${instalador.ApellidoNombre}`;
    },
    async getInstaladores() {
      this.isLoading = true;
      const resp = await axios.post("/execute", {
        method: "CLI.GetInstaladores",
        parameters: [],
      });
      if (resp.data.ok) {
        this.instaladorOptions = get(resp, "data.result[0]", []);
        this.adaptarVueModel(this.instaladorOptions, "id_instaladores");
      }
      this.isLoading = false;
      return resp.data;
    },
  },
  computed: {
    instalador: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
